var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-textarea',{attrs:{"rows":"3"},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}}),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors[0]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }